<template>
  <v-container>
    <h1>Translate DG file</h1>

    <progress-component
        script="TranslateDGFile"
        :formParams="[
            { type: 'file', name: 'file', value: null, label: 'Select file' },
            { type: 'checkbox', name: 'columns[text_slide]', value: true, label: 'Translate slide column' },
            { type: 'checkbox', name: 'columns[title]', value: false, label: 'Translate title column' },
            { type: 'checkbox', name: 'columns[text_author_slide]', value: false, label: 'Translate author column' },
        ]"
    />
  </v-container>
</template>

<script>

import ProgressComponent from '../components/ProgressComponent.vue';

export default {
  name: 'TranslateDG',
  components: { ProgressComponent },
};
</script>
